import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import * as Yup from "yup";
import Api from "../../Api";
import { ListCategories, NewCategoryModalForm } from "../../component";

const AppCategories = () => {
  interface Category {
    appCategoryId: number;
    appCategoryName: string;
  }

  const [categories, setCategories] = useState<Category[]>([]);

  const api = Api();

  const [selectedRecord, setSelectedRecord] = useState({
    categoryId: 0,
    category: "",
  });
  const [isEdit, setIsEdit] = useState(false);

  const CategoryValidationSchema = Yup.object().shape({
    categoryName: Yup.string().required("CategoryName is required"),
  });

  const handleCreateCategory = (categoryDetails: any) => {
    api.AppCategory.createAppCategory(categoryDetails).then((response: any) => {
      toast.success(response.message);
      getCategories();
    });
  };

  const getCategories = () => {
    api.AppCategory.getAppCategories().then((response: any)=>{
      if(response){
        setCategories([...response.appCategories])
      }
    })
  };

  const onCloseHandler = () => {
    setIsEdit(false);
  };

  useEffect(() => {
    getCategories();
  }, []);

  return (
    <div className="w-100 p-2">
      <div className="float-end">
        <NewCategoryModalForm
          CategoryValidationSchema={CategoryValidationSchema}
          onCreateNewCategory={handleCreateCategory}
          onClose={() => onCloseHandler()}
        />
      </div>

      <ListCategories categoriesList={categories} />
    </div>
  );
};

export default AppCategories;
